module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "transform-origin": "center",
      "transform": "rotate(-180deg)"
    },
    attrs: {
      "fill": "none",
      "height": "16",
      "viewBox": "0 0 20 16",
      "width": "20",
      "xmlns": "http://www.w3.org/2000/svg",
      "stroke": "black"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 15L1 8M1 8L8 1M1 8H19",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70cb568a","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/nextArrow.vue
// module id = 06c4264394fc3fb9cde4
// module chunks = 89